import { API } from '@/shared/api/modules';
import type { GetAdditionalChargesRequestDto } from '@/shared/api/modules/facilities';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getAdditionalChargesQueryOptions = (
  params: GetAdditionalChargesRequestDto
) =>
  queryOptions({
    queryKey: ['additional-charges', params],
    queryFn: async ({ signal }) =>
      await API.facilities.getAdditionalCharges(params, { signal }),
    placeholderData: keepPreviousData,
    enabled: !!params.from && !!params.to,
  });
